import { render } from "./ZahlungsMethode.vue?vue&type=template&id=023fa2c0"
import script from "./ZahlungsMethode.vue?vue&type=script&lang=js"
export * from "./ZahlungsMethode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__